import { Box, Button, FormField, Grommet, TextArea, TextInput } from "grommet";
import * as React from "react";

import { UploadComment } from "../utils/ServiceManagerAPI";

const CommentUpload = ({ questionId, questionnaireId, done }: { questionId: string; questionnaireId: string; done: Function }) => {
  const [commentText, setCommentText] = React.useState("");
  const [isLoaded, setIsLoaded] = React.useState(false);

  const uploadComment = () => {
    UploadComment({
      text: commentText,
      questionId: questionId,
      questionnaireId: questionnaireId,
    }).then((res) => {
      done(res);
    });
  };

  return (
    
      <Box>
        <FormField required error={!commentText && "Comment Empty"}>
          <TextArea autoFocus={true} value={commentText} onChange={(e) => setCommentText(e.target.value)} />
        </FormField>
        <Button label="Save" disabled={!commentText} onClick={uploadComment}></Button>
      </Box>
    
  );
};
export default CommentUpload;
